import { render, staticRenderFns } from "./configureTheSurchargeDialog.vue?vue&type=template&id=01f7e16e&scoped=true&"
import script from "./configureTheSurchargeDialog.vue?vue&type=script&lang=js&"
export * from "./configureTheSurchargeDialog.vue?vue&type=script&lang=js&"
import style1 from "./configureTheSurchargeDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7e16e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f7e16e')) {
      api.createRecord('01f7e16e', component.options)
    } else {
      api.reload('01f7e16e', component.options)
    }
    module.hot.accept("./configureTheSurchargeDialog.vue?vue&type=template&id=01f7e16e&scoped=true&", function () {
      api.rerender('01f7e16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/TariffTable/configureTheSurchargeDialog.vue"
export default component.exports